import { useGetUrl } from '@seek/ca-myprofile-utils';
import { metrics } from '@seek/metrics-js';
import { useTranslations } from '@vocab/react';
import { Heading, List, Stack, Text } from 'braid-design-system';
import React, { useEffect } from 'react';

import { ExternalLink } from 'src/components/ExternalLink/ExternalLink';
import { useAppConfig } from 'src/modules/appConfig';

import translations from './.vocab';
import { ErrorIllustration } from './svg/ErrorIllustration';

export const ShareableProfileErrorPage = ({
  error,
  isActive,
}: {
  error: boolean;
  isActive: boolean;
}) => {
  const { t } = useTranslations(translations);
  const { zone, language, isUnifiedSite } = useAppConfig();

  const getUrl = useGetUrl(zone, language, isUnifiedSite);

  useEffect(() => {
    const tags = [
      `server_error:${Boolean(error)}`,
      `active_profile:${isActive}`,
    ];
    metrics.count('shareable_profile_error_page', tags);
  }, [error, isActive]);

  return (
    <Stack space="xlarge" align="center">
      <ErrorIllustration />
      <Stack space="large" align="center">
        <Heading
          level="3"
          component="h1"
          align="center"
          data={{ automation: 'error-page-title' }}
        >
          {t("This shared profile isn't available")}
        </Heading>
        <Stack space="large">
          <Heading level="4" component="h2">
            <Text tone="secondary">
              {t('Need help viewing? Try these options:')}
            </Text>
          </Heading>
          <List space="small">
            <Text tone="secondary" size="small">
              {t('Check that the URL is correct')}
            </Text>
            <Text tone="secondary" size="small">
              {t('Get in touch with the owner')}
            </Text>
            <Text tone="secondary" size="small">
              {t('If this is your profile...')}
            </Text>
            <Text tone="secondary" size="small">
              {t('Visit our help centre', {
                ExternalLink: (v) => (
                  <ExternalLink href={getUrl('shareable-profile-faq-url')}>
                    {v}
                  </ExternalLink>
                ),
              })}
            </Text>
          </List>
        </Stack>
      </Stack>
    </Stack>
  );
};
